import { render, staticRenderFns } from "./CouponEntityDetails.vue?vue&type=template&id=6e34d7d9&scoped=true"
import script from "./CouponEntityDetails.vue?vue&type=script&lang=js"
export * from "./CouponEntityDetails.vue?vue&type=script&lang=js"
import style0 from "./CouponEntityDetails.vue?vue&type=style&index=0&id=6e34d7d9&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e34d7d9",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Mobaxe\\Nevo.SimAdmin.Web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6e34d7d9')) {
      api.createRecord('6e34d7d9', component.options)
    } else {
      api.reload('6e34d7d9', component.options)
    }
    module.hot.accept("./CouponEntityDetails.vue?vue&type=template&id=6e34d7d9&scoped=true", function () {
      api.rerender('6e34d7d9', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/CouponEntityDetails.vue"
export default component.exports